import React, { useState, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import Python3Sales from "./python3";
import SpiderSales from "./spider";
import axios from 'axios';
import PaySuccess from "./pay-success";
import MainSales from "./main";
import Algorithm from "./algorithm";
import DocumentTitle from 'react-document-title';

const Sales = () => {
  const [isLogin, setIsLogin] = useState(false);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, []);
  useEffect(() => {
    // 静默登录
    axios.get('/api/wx/is_login').then(response => {
      const { code, data } = response.data;
      if (code !== 0) {
        return;
      }
      if (data.is_login === false) {
        window.location.href = 'http://api.py2fun.com/wx/passport?scope=snsapi_base&next_url=' + encodeURIComponent(window.location.href);
      } else {
        setIsLogin(true)
        // 配置微信功能
      }
    })
  }, []);
  useEffect(() => {
    if (isLogin !== true) {
      return;
    }
    axios.post('/api/wx/js_ticket', {
      url: window.location.href.replace(/#.*$/, '')
    }).then(response => {
      const { code, data } = response.data;
      if (code === 0) {
        window.wx.config({
          ...data,
          debug: false,
          jsApiList: ['chooseWXPay']
        });
      }
    });
  }, [isLogin]);
  if (isLogin === false) {
    return <div>Loading...</div>;
  }
  return (
    <DocumentTitle title='夸克编程'>
      <Switch>
        <Route path='/sales/main' component={MainSales} />
        <Route path='/sales/python3' component={Python3Sales} />
        <Route path='/sales/spider' component={SpiderSales} />
        <Route path='/sales/algorithm' component={Algorithm} />
        <Route path='/sales/success/:orderId' component={PaySuccess} />
      </Switch>
    </DocumentTitle>
  );
};

export default Sales;
